import React, { useState } from 'react';
import { useAuth } from '../../AuthContext';
import './PracticeSurveys.css';

function CanadaSurvey() {
  const [answers, setAnswers] = useState({});
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const { userDetails } = useAuth();
  const apiUrl = process.env.REACT_APP_API_BASE_URL;


  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setAnswers(prevAnswers => ({
      ...prevAnswers,
      [name]: value
    }));
  };

  const handleNextQuestion = () => {
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(prevQuestion => prevQuestion + 1);
    }
  };

  const handlePreviousQuestion = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(prevQuestion => prevQuestion - 1);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const finalScore = calculateScore(answers);
    setSubmitted(true);

    // Ensure that the user is logged in before allowing score submission
    if (!userDetails.email) {
      alert("You must be logged in to submit scores.");
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/submit-score`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: userDetails.email, // Use email for score submission
          score: finalScore,
          surveyId: 'CanadaSurvey',
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to submit score');
      }

      alert('Score submitted successfully!');
    } catch (error) {
      console.error('Score submission error:', error);
      alert(error.message);
    }
  };

  const calculateScore = (answers) => {
    let score = 0;
    questions.forEach(question => {
      if (answers[question.id] === question.correctAnswer) {
        score += 10;  // Assuming each correct answer gives 10 points
      }
    });
    return score;
  };

  // Questions data
  const questions = [
    {
      id: 'largestCountry',
      label: 'What position does Canada occupy as the largest country in the world?',
      correctAnswer: '2nd',
      options: ['1st', '2nd', '3rd', '4th', '5th']
    },
    {
      id: 'officialLanguages',
      label: 'What are the official languages of Canada?',
      correctAnswer: 'English and French',
      options: ['English', 'French', 'Spanish', 'English and French', 'Italian']
    },
    {
      id: 'capital',
      label: 'What is the capital of Canada?',
      correctAnswer: 'Ottawa',
      options: ['Toronto', 'Montreal', 'Ottawa', 'Vancouver', 'Calgary']
    },
    {
      id: 'populatedProvinces',
      label: 'What are the three most populated provinces in the country?',
      correctAnswer: 'Vancouver, Ontario and Quebec',
      options: ['Alberta, Quebec, Ontario', 'Ontario, British Columbia, Quebec', 'Vancouver, Ontario and Quebec', 'Alberta, British Columbia, Quebec', 'Manitoba, Ontario, Quebec']
    },
    {
      id: 'winterTemperature',
      label: 'What is the average temperature during the winter season?',
      correctAnswer: '15 degrees Celsius',
      options: ['10 degrees Celsius', '15 degrees Celsius', '20 degrees Celsius', '5 degrees Celsius', '25 degrees Celsius']
    },
    {
      id: 'mapleSyrupProduction',
      label: 'How many percent of the worldwide maple syrup is produced in Canada?',
      correctAnswer: '85 percent',
      options: ['75 percent', '80 percent', '85 percent', '90 percent', '95 percent']
    },
    {
      id: 'mapleSyrupIncome',
      label: 'Is maple syrup an income source for the country?',
      correctAnswer: 'yes',
      options: ['yes', 'no']
    },
    {
      id: 'nationalSport',
      label: 'What is the national sport of Canada?',
      correctAnswer: 'Hockey',
      options: ['Hockey', 'Baseball', 'Soccer', 'Football', 'Basketball']
    },
    {
      id: 'nationalAnimal',
      label: 'What is the national animal of Canada?',
      correctAnswer: 'Beaver',
      options: ['Beaver', 'Moose', 'Polar Bear', 'Caribou', 'Grizzly Bear']
    },
    {
      id: 'happinessRank',
      label: 'What position does Canada occupy as the happiest population in the world?',
      correctAnswer: '2nd',
      options: ['1st', '2nd', '3rd', '4th', '5th']
    },
    {
      id: 'primeMinister',
      label: 'Who is the current prime minister of Canada?',
      correctAnswer: 'Justin Trudeau',
      options: ['Justin Trudeau', 'Stephen Harper', 'Paul Martin', 'Jean Chrétien', 'Brian Mulroney']
    }
  ];

  return (
    <div className="container">
      {!submitted && (
        <div className="card mt-4">
          <div className="card-body">
            <h2>Canada Survey</h2>
            <form onSubmit={handleSubmit}>
              <div className="survey-question">
                <label htmlFor={questions[currentQuestion].id}>{questions[currentQuestion].label}</label>
                <select
                  className="form-control"
                  id={questions[currentQuestion].id}
                  name={questions[currentQuestion].id}
                  value={answers[questions[currentQuestion].id]}
                  onChange={handleInputChange}
                >
                  <option value="">Select an option</option>
                  {questions[currentQuestion].options.map((option, index) => (
                    <option key={index} value={option}>{option}</option>
                  ))}
                </select>
              </div>
              <div className="survey-navigation">
                {currentQuestion > 0 && <button type="button" className="btn btn-secondary" onClick={handlePreviousQuestion}>Previous</button>}
                {currentQuestion < questions.length - 1 && <button type="button" className="btn btn-primary" onClick={handleNextQuestion}>Next</button>}
                {currentQuestion === questions.length - 1 && <button type="submit" className="btn btn-success">Submit</button>}
              </div>
            </form>
          </div>
        </div>
      )}
      {submitted && (
        <div className="card mt-4">
          <div className="card-body">
            <h3>Your Answers:</h3>
            {questions.map(question => (
              <div key={question.id}>
                <p><strong>{question.label}</strong></p>
                <p>Your answer: {answers[question.id]}</p>
                <p>Correct answer: {question.correctAnswer}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default CanadaSurvey;